export const css = {
    root: 'wasN-YeL',
    header: '_35cZa3qG',
    noTable: 'IJT7Sjth',
    recommendedList: '_1zH8DC8U',
    button: '_1M0YbPvh',
    row: '_3poAPPGJ',
    headerClass: '_1gxPMWjv',
    action: '_2CM4He3T',
    complete: '_21AkqU8h',
    ' _key': 'dashboard-widgets/recommended-next-steps'
};
export default css;
